import styles from "./IlluHandshake.module.css";

export function IlluHandshake() {
  return (
    <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
      <path className={styles.cls2} d="M108.05,168.69c-.17-.1-.33-.2-.49-.29" />
      <path className={styles.cls2} d="M84.68,150.2c4.29,4.19,10.45,10.55,13.24,12.89" />
      <path
        className={styles.cls2}
        d="M146.98,196.04c8.54,8.17,12.15-2.86,12.52-3.62.03-.06.27-.24.7-.53-2.59-.72-6.34-2.46-9.21-3.9"
      />
      <path className={styles.cls2} d="M138.75,189.16c-.17-.12-.35-.25-.53-.38" />
      <path
        className={styles.cls2}
        d="M104.52,114.44c2.74,1.41,6.78,3.03,10.29,2.66,5.13-.54,29.16-7.62,32.73-5.44h.01"
      />
      <path
        className={styles.cls2}
        d="M156.44,137c14.23,15.62,37.75,31.81,37.97,31.97.91.69,1.34,1.3,2.03,2.13,2,2.43,3.24,12.22-9.02,7.88-.72-.26-1.45-.54-2.19-.87.08,1.12.05,2.6-.23,4.1-.79,4.23-3.65,8.54-12.12,4.68-4.41-1.32-8.59-3.72-12.15-6.26"
      />
      <path className={styles.cls1} d="M129.16,182.32s0,0-.01.02" />
      <path
        className={styles.cls3}
        d="M144.17,180.94c-.3.58-.67,1.14-1.11,1.67-1.8,2.2-3.39,4.31-4.84,6.17-4.98,6.39-8.27,9.8-12.96,3.67-1.47-1.92.67-5.84,3.5-9.59-4.61,4.98-10.02,9.23-14.35,3.03-.18-.25-.32-.51-.43-.78-9.62,2.33-17.93,5.65-23.91,10.09-12.26,9.1-19.94,19.54,1.25,27.75,21.19,8.21,121.53,5.89,131.76-.28,10.22-6.16,12.43-10.81,7.68-23.69-2.91-7.86-22.04-14-45.76-16.77-.79,4.23-3.65,8.54-12.12,4.68-.19,3.98-1.6,9.06-12.23,5.17-.15-.05-.3-.11-.45-.17-.43.29-.67.47-.7.53-.37.76-3.98,11.79-12.52,3.62-5.34,8.05-12.71-.16-11.03-2.68,1.03-1.55,1.96-2.95,2.8-4.2,3.31-4.91,5.33-7.53,7.25-8.31"
      />
      <path
        className={styles.cls2}
        d="M272.44,127.41l-40.34,24.25-1.64-2.91s-.07-.15-.21-.44c-1.91-3.93-16.3-33.3-24.46-43.24-.07-.08-.14-.2-.23-.33-.53-.81-1.29-2.35-1.29-2.35l43.92-30.64"
      />
      <path
        className={styles.cls3}
        d="M230.26,148.31l-15.13,8.33-1.53-2.8-21.22-38.79-.99-1.81,14.18-8.5c.09.13.16.25.23.33,8.16,9.94,22.55,39.31,24.46,43.24Z"
      />
      <path
        className={styles.cls2}
        d="M174.78,146.56c-3.28-.86-6.16-1.96-8.67-3.19-10.57-5.11-14.7-12.27-15.84-11.75-5.19,2.36-14.3,2.68-14.3,2.68-6.16,10.86-17.84,7.86-19.53,5.49-2.21-3.1,9.45-14.94,11.62-17.87,1.69-2.29,11.82-6.82,18.99-10.04,2.04-.91,3.84-1.72,5.14-2.34,5.87-2.81,33.57,9.83,33.57,9.83l6.61-4.32"
      />
      <path
        className={styles.cls2}
        d="M194.41,168.97c8.33-5.15,10.63-11.18,10.63-11.18l8.55-3.95"
      />
      <path
        className={styles.cls2}
        d="M104.86,157.2s-11.52,6.47-7.43,12.21c4.09,5.74,8.17.82,14.81-5.4,4.09-3.83-1.28-10.81-7.37-6.81Z"
      />
      <path
        className={styles.cls2}
        d="M124.64,168.83c2.23-4.98-1.86-11.56-8.29-7.21,0,0-15.36,10.33-11.29,16.21,3.19,4.61,6.36,3.76,10.34.5"
      />
      <path
        className={styles.cls2}
        d="M129.16,182.32h.01c2.07-2.68,4.43-5.23,5.99-6.84h.01c3.71-5.7-.84-13.68-8.42-8.26,0,0-.85.6-2.11,1.61-2.56,2.04-6.84,5.74-9.24,9.5-1.53,2.37-2.3,4.77-1.42,6.78.11.27.25.53.43.78,4.33,6.2,9.74,1.95,14.35-3.03.13-.17.26-.35.39-.52"
      />
      <path
        className={styles.cls2}
        d="M144.17,180.94c-.3.58-.67,1.14-1.11,1.67-1.8,2.2-3.39,4.31-4.84,6.17-4.98,6.39-8.27,9.8-12.96,3.67-1.47-1.92.67-5.84,3.5-9.59.13-.17.26-.35.39-.52t.01-.02h.01c2.07-2.68,4.43-5.23,5.99-6.84h.01c1.02-1.08,1.7-1.73,1.7-1.73,6.92-5.92,10.47,1.31,7.3,7.19Z"
      />
      <path
        className={styles.cls2}
        d="M151,187.99c-.68,1.65-1.72,3.78-3.14,6.56-.28.55-.57,1.05-.87,1.49-5.34,8.05-12.71-.16-11.03-2.68,1.03-1.55,1.96-2.95,2.8-4.2,3.31-4.91,5.33-7.53,7.25-8.31.75-.04,1.5-.07,2.26-.09.24.06.48.15.73.27,3,1.4,3.87,2.39,2,6.96Z"
      />
      <path
        className={styles.cls2}
        d="M148.27,180.76c-.76.02-1.51.05-2.26.09.75-.31,1.47-.33,2.26-.09Z"
      />
      <path
        className={styles.cls3}
        d="M106.61,110.68l-1.36,2.45-20.36,36.68-1.43,2.58-13.38-7.97c3.89-9.72,13.29-31.88,21.99-42.18l14.54,8.44Z"
      />
      <path
        className={styles.cls2}
        d="M27.55,127.84l40.68,21.31s.67-1.8,1.85-4.73c3.89-9.72,13.29-31.88,21.99-42.18.51-.61,1.02-1.17,1.52-1.69l-38.47-24.59"
      />
      <path className={styles.cls2} d="M158.95,160.2s14.87,13.43,26.28,17.91" />
      <path
        className={styles.cls2}
        d="M149.99,171.1s4.36,4.99,10.74,9.53c3.56,2.54,7.74,4.94,12.15,6.26"
      />
      <path className={styles.cls2} d="M150.99,187.99c2.87,1.44,6.62,3.18,9.21,3.9" />
    </svg>
  );
}
